<template>
  <div class="row no-wrap">
    <default-checkbox :value="agreeLegalConditions" v-on="$listeners">
      <div>
        <span>אני מאשר.ת שקראתי ואישרתי את </span>
        <span class="r-link-button" @click.stop="openJoinStatement">טופס ההצהרות והאישורים</span>
      </div>
    </default-checkbox>
  </div>
</template>

<script>
import DefaultCheckbox from '@/components/styled/DefaultCheckbox';

export default {
  name: 'AgreeLegalConditions',
  components: { DefaultCheckbox },
  props: {
    agreeLegalConditions: Boolean,
  },
  methods: {
    openJoinStatement() {
      window.open('/pdfs/join-statements.pdf', '_blank');
    },
  },
};
</script>
